import {SVGProps} from "react";

export const MarkerSvg = (props: SVGProps<SVGSVGElement>) => (<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_4109_4053)">
      <path
        d="M7 0C10.8658 4.95629e-08 13.9997 2.4108 14 5.38477C14 7.1465 12.9002 8.71086 11.2002 9.69336C9.9036 10.4415 8.04122 11.6239 7.56445 13.5303C7.50642 13.7617 7.32645 13.9474 7.09961 13.9902L7 14C6.72741 14 6.50184 13.7947 6.43555 13.5303C5.95878 11.6239 4.0964 10.4415 2.7998 9.69336C1.09978 8.71086 0 7.1465 0 5.38477C0.000336795 2.4108 3.13421 0 7 0Z"
        fill="currentColor" />
    </g>
    <defs>
      <clipPath id="clip0_4109_4053">
        <rect width="14" height="14" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>);
